import React, { Fragment } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Text } from '@daedalus/atlas/Text';
interface Props {
  /** Array of string values that will be separated with dot */
  values: string[];
  /** If true, the list will be displayed in a single line */
  isSingleLine?: boolean;
}
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1kssdu7",
  propsAsIs: false
});
export const DotSeparatedList = ({
  values,
  isSingleLine
}: Props) => {
  return <Wrapper className={cx(isSingleLine && 'isSingleLine')}>
      {values.filter(value => !!value?.length).map((value, index) => <Fragment key={`${value}${index}`}>
            {index > 0 && <Text variant="bodyXS" as="span">
                &nbsp;·&nbsp;
              </Text>}
            <Text variant="bodyXS" as="span">
              {value}
            </Text>
          </Fragment>)}
    </Wrapper>;
};

require("./DotSeparatedList.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./DotSeparatedList.tsx");